import { Injectable } from "@angular/core";
import { createEffect, ofType, Actions } from "@ngrx/effects";
import { switchMap } from "rxjs/operators";
import { of } from "rxjs";

import { ProductAPIResponse } from "../models/productresponse.model";
import { ProductService } from "../../shared/services/product.service";
import {
  EProductActions,
  GetProduct,
  GetAllProduct,
  GetProductSuccess,
  GetAllProductSuccess,
  GetSingleProduct,
  GetSingleProductSuccess,
} from "../actions/product.actions";
import { ProductListAPIResponse } from "../models/productlistresponse.model";

@Injectable()
export class ProductEffects {
  getProduct$ = createEffect(() =>
    this._actions$.pipe(
      ofType<GetProduct>(EProductActions.GetProduct),
      switchMap((action) => this._ProductService.getProducts(action.payload)),
      switchMap((Products: ProductListAPIResponse) => {
        return of(new GetProductSuccess(Products));
      })
    )
  );

  getAllProduct$ = createEffect(() =>
    this._actions$.pipe(
      ofType<GetAllProduct>(EProductActions.GetAllProduct),
      switchMap((action) => this._ProductService.getAllProducts()),
      switchMap((AllProducts: ProductListAPIResponse) => {
        return of(new GetAllProductSuccess(AllProducts));
      })
    )
  );

  getSingleProduct$ = createEffect(() =>
    this._actions$.pipe(
      ofType<GetSingleProduct>(EProductActions.GetSingleProduct),
      switchMap((action) =>
        this._ProductService.getSingleProduct(action.payload)
      ),
      switchMap((product: ProductAPIResponse) => {
        return of(new GetSingleProductSuccess(product));
      })
    )
  );
  constructor(
    private _ProductService: ProductService,
    private _actions$: Actions
  ) {}
}
